/**
 * Client Administrative Portal route bases.
 * CasaMapa and Midpoint Media live under the product public namespace; other products keep /client.
 */

export const CLIENT_ADMIN_PORTAL_LEGACY_BASE = "/client";
export const CASAMAPA_ADMIN_PORTAL_BASE = "/v/casamapa/admin";
export const CASAMAPA_ADMIN_PORTAL_SLUG = "casamapa";
export const MIDPOINT_MEDIA_ADMIN_PORTAL_BASE = "/v/midpoint-media/admin";
export const MIDPOINT_MEDIA_ADMIN_PORTAL_SLUG = "midpoint-media";

export function resolveClientAdminPortalBase(pathname = "") {
  const path = String(pathname || "");
  if (path === CASAMAPA_ADMIN_PORTAL_BASE || path.startsWith(`${CASAMAPA_ADMIN_PORTAL_BASE}/`)) {
    return CASAMAPA_ADMIN_PORTAL_BASE;
  }
  if (
    path === MIDPOINT_MEDIA_ADMIN_PORTAL_BASE ||
    path.startsWith(`${MIDPOINT_MEDIA_ADMIN_PORTAL_BASE}/`)
  ) {
    return MIDPOINT_MEDIA_ADMIN_PORTAL_BASE;
  }
  return CLIENT_ADMIN_PORTAL_LEGACY_BASE;
}

export function clientAdminPortalBaseForSlug(slug) {
  if (slug === CASAMAPA_ADMIN_PORTAL_SLUG) {
    return CASAMAPA_ADMIN_PORTAL_BASE;
  }
  if (slug === MIDPOINT_MEDIA_ADMIN_PORTAL_SLUG) {
    return MIDPOINT_MEDIA_ADMIN_PORTAL_BASE;
  }
  return CLIENT_ADMIN_PORTAL_LEGACY_BASE;
}

export function clientAdminPortalPath(base, ...segments) {
  const root = String(base || CLIENT_ADMIN_PORTAL_LEGACY_BASE).replace(/\/+$/, "") || CLIENT_ADMIN_PORTAL_LEGACY_BASE;
  const tail = segments
    .filter((part) => part !== undefined && part !== null && String(part).length > 0)
    .map((part) => String(part).replace(/^\/+|\/+$/g, ""))
    .filter(Boolean)
    .join("/");
  return tail ? `${root}/${tail}` : root;
}

export function buildClientAdminPortalPaths(base = CLIENT_ADMIN_PORTAL_LEGACY_BASE) {
  return {
    base,
    login: clientAdminPortalPath(base, "login"),
    logout: clientAdminPortalPath(base, "logout"),
    acceptInvitation: clientAdminPortalPath(base, "accept-invitation"),
    changePassword: clientAdminPortalPath(base, "change-password"),
    dashboard: clientAdminPortalPath(base, "dashboard"),
    views: clientAdminPortalPath(base, "views"),
    view: (clientViewId) => clientAdminPortalPath(base, "views", clientViewId),
    viewSection: (clientViewId, ...sections) =>
      clientAdminPortalPath(base, "views", clientViewId, ...sections),
  };
}
